var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Button from "../button/button";
import React from 'react';
export default function CardAlt({ bg_color, buttons, content, image, title, logo, logo_width }) {
    const { unit, size } = logo_width || {};
    const default_width = `${size}${unit}` === '50%';
    const bg_style = bg_color ? { style: { backgroundColor: bg_color } } : null;
    return (React.createElement("div", Object.assign({ className: "ltg-card-alt" }, bg_style),
        React.createElement("div", { className: "ltg-card" },
            React.createElement("div", { className: "ltg-card-col-img" },
                logo && React.createElement(CardImage, { image: logo, title: title, width: !default_width ? `${size}${unit}` : null, className: "ltg-card--logo" }),
                image && React.createElement(CardImage, { image: image, title: title, className: "ltg-card--main-img" })),
            React.createElement("div", { className: "ltg-card-col-text" },
                title && (React.createElement("h2", { className: 'ltg-card-title' }, title)),
                content && (React.createElement("div", { className: "ltg-card-content", dangerouslySetInnerHTML: { __html: content } })),
                buttons && (React.createElement(ButtonList, { buttons: buttons }))))));
}
function CardImage({ image, title, className, width }) {
    const { alt, id, url } = image || {};
    if (!url)
        return null;
    const width_style = width ? { style: { width } } : null;
    return (React.createElement("div", { className: `ltg-card-logo-wrap${className ? ` ${className}` : ''}` },
        React.createElement("img", Object.assign({ src: url, alt: alt || title }, width_style))));
}
function ButtonList({ buttons }) {
    if (buttons === null || buttons === void 0 ? void 0 : buttons.length)
        return (React.createElement("div", { className: "ltg-card-buttons" }, buttons && buttons.map((_a) => {
            var { _id } = _a, rest = __rest(_a, ["_id"]);
            return (React.createElement(Button, Object.assign({ key: _id }, rest)));
        })));
}
